import React from "react";
import "./style.less";

function Separate({ src, className = "", width, scale, radius = 0 }) {
  return (
    <div
      className={`com-ImgContainer ${className}`}
      style={{
        width: width + "px",
        minWidth: width + "px",
        height: width * scale + "px",
        backgroundColor: "#ccc",
        borderRadius: radius + "px",
      }}
    >
      <img width="w-full h-full object-cover" src={src} alt="" />
    </div>
  );
}

export default Separate;
